// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/v1/billing.proto" (package "viam.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message viam.app.v1.InvoiceSummary
 */
export interface InvoiceSummary {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp invoice_date = 2;
     */
    invoiceDate?: Timestamp;
    /**
     * @generated from protobuf field: double invoice_amount = 3;
     */
    invoiceAmount: number;
    /**
     * @generated from protobuf field: string status = 4;
     */
    status: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 5;
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp paid_date = 6;
     */
    paidDate?: Timestamp;
    /**
     * Category of the most recent payment failure. One of: card_declined,
     * insufficient_funds, expired_card, incorrect_cvc, incorrect_card_number,
     * authentication_required, processing_error, other. Empty when no failure
     * is recorded. Clients must tolerate unknown values.
     *
     * @generated from protobuf field: string last_payment_failure_reason = 7;
     */
    lastPaymentFailureReason: string;
    /**
     * Time of the most recent payment failure. Empty when no failure recorded.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_payment_failure_at = 8;
     */
    lastPaymentFailureAt?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.PaymentMethodCard
 */
export interface PaymentMethodCard {
    /**
     * @generated from protobuf field: string brand = 1;
     */
    brand: string;
    /**
     * @generated from protobuf field: string last_four_digits = 2;
     */
    lastFourDigits: string;
}
/**
 * @generated from protobuf message viam.app.v1.VerificationInfo
 */
export interface VerificationInfo {
    /**
     * @generated from protobuf field: int64 arrival_date = 1;
     */
    arrivalDate: string;
    /**
     * @generated from protobuf field: string hosted_verification_page_url = 2;
     */
    hostedVerificationPageUrl: string;
}
/**
 * @generated from protobuf message viam.app.v1.PaymentMethodUSBankAccount
 */
export interface PaymentMethodUSBankAccount {
    /**
     * @generated from protobuf field: string bank_name = 1;
     */
    bankName: string;
    /**
     * @generated from protobuf field: string last_four_digits_account_number = 2;
     */
    lastFourDigitsAccountNumber: string;
    /**
     * @generated from protobuf field: string routing_number = 3;
     */
    routingNumber: string;
    /**
     * @generated from protobuf field: string account_type = 4;
     */
    accountType: string;
    /**
     * @generated from protobuf field: optional viam.app.v1.VerificationInfo verification_info = 5;
     */
    verificationInfo?: VerificationInfo; // this is only set if the account is not verified
}
/**
 * @generated from protobuf message viam.app.v1.GetCurrentMonthUsageRequest
 */
export interface GetCurrentMonthUsageRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.UsageCost
 */
export interface UsageCost {
    /**
     * @generated from protobuf field: viam.app.v1.UsageCostType resource_type = 1;
     */
    resourceType: UsageCostType;
    /**
     * @generated from protobuf field: double cost = 2;
     */
    cost: number;
}
/**
 * @generated from protobuf message viam.app.v1.ResourceUsageCostsBySource
 */
export interface ResourceUsageCostsBySource {
    /**
     * @generated from protobuf field: viam.app.v1.SourceType source_type = 1;
     */
    sourceType: SourceType;
    /**
     * @generated from protobuf field: viam.app.v1.ResourceUsageCosts resource_usage_costs = 2;
     */
    resourceUsageCosts?: ResourceUsageCosts;
    /**
     * @generated from protobuf field: string tier_name = 3;
     */
    tierName: string;
}
/**
 * @generated from protobuf message viam.app.v1.ResourceUsageCosts
 */
export interface ResourceUsageCosts {
    /**
     * @generated from protobuf field: repeated viam.app.v1.UsageCost usage_costs = 1;
     */
    usageCosts: UsageCost[];
    /**
     * @generated from protobuf field: double discount = 2;
     */
    discount: number;
    /**
     * @generated from protobuf field: double total_with_discount = 3;
     */
    totalWithDiscount: number;
    /**
     * @generated from protobuf field: double total_without_discount = 4;
     */
    totalWithoutDiscount: number;
}
/**
 * @generated from protobuf message viam.app.v1.GetCurrentMonthUsageResponse
 */
export interface GetCurrentMonthUsageResponse {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 1;
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 2;
     */
    endDate?: Timestamp;
    /**
     * @generated from protobuf field: repeated viam.app.v1.ResourceUsageCostsBySource resource_usage_costs_by_source = 14;
     */
    resourceUsageCostsBySource: ResourceUsageCostsBySource[];
    /**
     * @generated from protobuf field: double subtotal = 15;
     */
    subtotal: number;
    /**
     * all fields below are deprecated
     *
     * @deprecated
     * @generated from protobuf field: double cloud_storage_usage_cost = 3 [deprecated = true];
     */
    cloudStorageUsageCost: number;
    /**
     * @deprecated
     * @generated from protobuf field: double data_upload_usage_cost = 4 [deprecated = true];
     */
    dataUploadUsageCost: number;
    /**
     * @deprecated
     * @generated from protobuf field: double data_egres_usage_cost = 5 [deprecated = true];
     */
    dataEgresUsageCost: number;
    /**
     * @deprecated
     * @generated from protobuf field: double remote_control_usage_cost = 6 [deprecated = true];
     */
    remoteControlUsageCost: number;
    /**
     * @deprecated
     * @generated from protobuf field: double standard_compute_usage_cost = 7 [deprecated = true];
     */
    standardComputeUsageCost: number;
    /**
     * @deprecated
     * @generated from protobuf field: double discount_amount = 8 [deprecated = true];
     */
    discountAmount: number;
    /**
     * @deprecated
     * @generated from protobuf field: double total_usage_with_discount = 9 [deprecated = true];
     */
    totalUsageWithDiscount: number;
    /**
     * @deprecated
     * @generated from protobuf field: double total_usage_without_discount = 10 [deprecated = true];
     */
    totalUsageWithoutDiscount: number;
    /**
     * @deprecated
     * @generated from protobuf field: double per_machine_usage_cost = 11 [deprecated = true];
     */
    perMachineUsageCost: number;
    /**
     * @deprecated
     * @generated from protobuf field: double binary_data_cloud_storage_usage_cost = 12 [deprecated = true];
     */
    binaryDataCloudStorageUsageCost: number;
    /**
     * @deprecated
     * @generated from protobuf field: double other_cloud_storage_usage_cost = 13 [deprecated = true];
     */
    otherCloudStorageUsageCost: number;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrgBillingInformationRequest
 */
export interface GetOrgBillingInformationRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrgBillingInformationResponse
 */
export interface GetOrgBillingInformationResponse {
    /**
     * @generated from protobuf field: viam.app.v1.PaymentMethodType type = 1;
     */
    type: PaymentMethodType;
    /**
     * @generated from protobuf field: string billing_email = 2;
     */
    billingEmail: string;
    /**
     * defined if type is PAYMENT_METHOD_TYPE_CARD
     *
     * @generated from protobuf field: optional viam.app.v1.PaymentMethodCard method = 3;
     */
    method?: PaymentMethodCard;
    /**
     * Only return billing_tier for billing dashboard admin users
     *
     * @generated from protobuf field: optional string billing_tier = 4;
     */
    billingTier?: string;
    /**
     * defined if type is PAYMENT_METHOD_TYPE_USBANKACCOUNT
     *
     * @generated from protobuf field: optional viam.app.v1.PaymentMethodUSBankAccount method_us_bank_account = 5;
     */
    methodUsBankAccount?: PaymentMethodUSBankAccount;
}
/**
 * @generated from protobuf message viam.app.v1.GetInvoicesSummaryRequest
 */
export interface GetInvoicesSummaryRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetInvoicesSummaryResponse
 */
export interface GetInvoicesSummaryResponse {
    /**
     * all unpaid balances at the end of the last billing cycle
     *
     * @generated from protobuf field: double outstanding_balance = 1;
     */
    outstandingBalance: number;
    /**
     * all previous invoices
     *
     * @generated from protobuf field: repeated viam.app.v1.InvoiceSummary invoices = 2;
     */
    invoices: InvoiceSummary[];
}
/**
 * @generated from protobuf message viam.app.v1.GetInvoicePdfRequest
 */
export interface GetInvoicePdfRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string org_id = 2;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetInvoicePdfResponse
 */
export interface GetInvoicePdfResponse {
    /**
     * @generated from protobuf field: bytes chunk = 1;
     */
    chunk: Uint8Array;
}
/**
 * @generated from protobuf message viam.app.v1.SendPaymentRequiredEmailRequest
 */
export interface SendPaymentRequiredEmailRequest {
    /**
     * @generated from protobuf field: string customer_org_id = 1;
     */
    customerOrgId: string;
    /**
     * @generated from protobuf field: string billing_owner_org_id = 2;
     */
    billingOwnerOrgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.SendPaymentRequiredEmailResponse
 */
export interface SendPaymentRequiredEmailResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetAvailableBillingTiersRequest
 */
export interface GetAvailableBillingTiersRequest {
}
/**
 * @generated from protobuf message viam.app.v1.GetAvailableBillingTiersResponse
 */
export interface GetAvailableBillingTiersResponse {
    /**
     * @generated from protobuf field: repeated string tiers = 1;
     */
    tiers: string[];
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationBillingTierRequest
 */
export interface UpdateOrganizationBillingTierRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string billing_tier = 2;
     */
    billingTier: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationBillingTierResponse
 */
export interface UpdateOrganizationBillingTierResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetLocationBillingOrganizationRequest
 */
export interface GetLocationBillingOrganizationRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetLocationBillingOrganizationResponse
 */
export interface GetLocationBillingOrganizationResponse {
    /**
     * @generated from protobuf field: string billing_organization_id = 1;
     */
    billingOrganizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateLocationBillingOrganizationRequest
 */
export interface UpdateLocationBillingOrganizationRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string billing_organization_id = 2;
     */
    billingOrganizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateLocationBillingOrganizationResponse
 */
export interface UpdateLocationBillingOrganizationResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ChargeOrganizationRequest
 */
export interface ChargeOrganizationRequest {
    /**
     * @generated from protobuf field: string org_id_to_charge = 1;
     */
    orgIdToCharge: string;
    /**
     * @generated from protobuf field: optional string description = 2;
     */
    description?: string;
    /**
     * @generated from protobuf field: double subtotal = 3;
     */
    subtotal: number;
    /**
     * @generated from protobuf field: double tax = 4;
     */
    tax: number;
    /**
     * @generated from protobuf field: optional string org_id_for_branding = 5;
     */
    orgIdForBranding?: string;
    /**
     * @generated from protobuf field: bool disable_confirmation_email = 6;
     */
    disableConfirmationEmail: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.ChargeOrganizationResponse
 */
export interface ChargeOrganizationResponse {
    /**
     * @generated from protobuf field: string invoice_id = 1;
     */
    invoiceId: string;
}
/**
 * Deprecated: Use ChargeOrganizationRequest instead
 *
 * @generated from protobuf message viam.app.v1.CreateInvoiceAndChargeImmediatelyRequest
 */
export interface CreateInvoiceAndChargeImmediatelyRequest {
    /**
     * @generated from protobuf field: string org_id_to_charge = 1;
     */
    orgIdToCharge: string;
    /**
     * @generated from protobuf field: double amount = 2;
     */
    amount: number;
    /**
     * @generated from protobuf field: optional string description = 3;
     */
    description?: string;
    /**
     * @generated from protobuf field: optional string org_id_for_branding = 4;
     */
    orgIdForBranding?: string;
    /**
     * @generated from protobuf field: bool disable_email = 5;
     */
    disableEmail: boolean;
}
/**
 * Deprecated: Use ChargeOrganizationResponse instead
 *
 * @generated from protobuf message viam.app.v1.CreateInvoiceAndChargeImmediatelyResponse
 */
export interface CreateInvoiceAndChargeImmediatelyResponse {
    /**
     * @generated from protobuf field: string invoice_id = 1;
     */
    invoiceId: string;
}
/**
 * @generated from protobuf enum viam.app.v1.PaymentMethodType
 */
export enum PaymentMethodType {
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_TYPE_CARD = 1;
     */
    CARD = 1,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_TYPE_USBANKACCOUNT = 2;
     */
    USBANKACCOUNT = 2
}
/**
 * @generated from protobuf enum viam.app.v1.UsageCostType
 */
export enum UsageCostType {
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @deprecated
     * @generated from protobuf enum value: USAGE_COST_TYPE_DATA_UPLOAD = 1 [deprecated = true];
     */
    DATA_UPLOAD = 1,
    /**
     * @deprecated
     * @generated from protobuf enum value: USAGE_COST_TYPE_DATA_EGRESS = 2 [deprecated = true];
     */
    DATA_EGRESS = 2,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_REMOTE_CONTROL = 3;
     */
    REMOTE_CONTROL = 3,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_STANDARD_COMPUTE = 4;
     */
    STANDARD_COMPUTE = 4,
    /**
     * @deprecated
     * @generated from protobuf enum value: USAGE_COST_TYPE_CLOUD_STORAGE = 5 [deprecated = true];
     */
    CLOUD_STORAGE = 5,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_BINARY_DATA_CLOUD_STORAGE = 6;
     */
    BINARY_DATA_CLOUD_STORAGE = 6,
    /**
     * @deprecated
     * @generated from protobuf enum value: USAGE_COST_TYPE_OTHER_CLOUD_STORAGE = 7 [deprecated = true];
     */
    OTHER_CLOUD_STORAGE = 7,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_PER_MACHINE = 8;
     */
    PER_MACHINE = 8,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TRIGGER_NOTIFICATION = 9;
     */
    TRIGGER_NOTIFICATION = 9,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TABULAR_DATA_CLOUD_STORAGE = 10;
     */
    TABULAR_DATA_CLOUD_STORAGE = 10,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_CONFIG_HISTORY_CLOUD_STORAGE = 11;
     */
    CONFIG_HISTORY_CLOUD_STORAGE = 11,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_LOGS_CLOUD_STORAGE = 12;
     */
    LOGS_CLOUD_STORAGE = 12,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TRAINING_LOGS_CLOUD_STORAGE = 13;
     */
    TRAINING_LOGS_CLOUD_STORAGE = 13,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_PACKAGES_CLOUD_STORAGE = 14;
     */
    PACKAGES_CLOUD_STORAGE = 14,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_BINARY_DATA_UPLOAD = 15;
     */
    BINARY_DATA_UPLOAD = 15,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TABULAR_DATA_UPLOAD = 16;
     */
    TABULAR_DATA_UPLOAD = 16,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_LOGS_UPLOAD = 17;
     */
    LOGS_UPLOAD = 17,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_BINARY_DATA_EGRESS = 18;
     */
    BINARY_DATA_EGRESS = 18,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TABULAR_DATA_EGRESS = 19;
     */
    TABULAR_DATA_EGRESS = 19,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_LOGS_EGRESS = 20;
     */
    LOGS_EGRESS = 20,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TRAINING_LOGS_EGRESS = 21;
     */
    TRAINING_LOGS_EGRESS = 21,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TABULAR_DATA_DATABASE_CLOUD_STORAGE = 22;
     */
    TABULAR_DATA_DATABASE_CLOUD_STORAGE = 22,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_TABULAR_DATA_DATABASE_COMPUTE = 23;
     */
    TABULAR_DATA_DATABASE_COMPUTE = 23,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_BINARY_DATA_CROSS_REGION_EGRESS = 24;
     */
    BINARY_DATA_CROSS_REGION_EGRESS = 24,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_PIPELINE_SINK_CLOUD_STORAGE = 25;
     */
    PIPELINE_SINK_CLOUD_STORAGE = 25,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_PIPELINE_SINK_COMPUTE = 26;
     */
    PIPELINE_SINK_COMPUTE = 26,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_PREMIUM_MODULE = 27;
     */
    PREMIUM_MODULE = 27,
    /**
     * @generated from protobuf enum value: USAGE_COST_TYPE_SIMULATION_COMPUTE = 28;
     */
    SIMULATION_COMPUTE = 28
}
/**
 * @generated from protobuf enum viam.app.v1.SourceType
 */
export enum SourceType {
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_ORG = 1;
     */
    ORG = 1,
    /**
     * @generated from protobuf enum value: SOURCE_TYPE_FRAGMENT = 2;
     */
    FRAGMENT = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceSummary$Type extends MessageType<InvoiceSummary> {
    constructor() {
        super("viam.app.v1.InvoiceSummary", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "invoice_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "invoice_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "due_date", kind: "message", T: () => Timestamp },
            { no: 6, name: "paid_date", kind: "message", T: () => Timestamp },
            { no: 7, name: "last_payment_failure_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "last_payment_failure_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.InvoiceSummary
 */
export const InvoiceSummary = new InvoiceSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentMethodCard$Type extends MessageType<PaymentMethodCard> {
    constructor() {
        super("viam.app.v1.PaymentMethodCard", [
            { no: 1, name: "brand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_four_digits", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.PaymentMethodCard
 */
export const PaymentMethodCard = new PaymentMethodCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerificationInfo$Type extends MessageType<VerificationInfo> {
    constructor() {
        super("viam.app.v1.VerificationInfo", [
            { no: 1, name: "arrival_date", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "hosted_verification_page_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.VerificationInfo
 */
export const VerificationInfo = new VerificationInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentMethodUSBankAccount$Type extends MessageType<PaymentMethodUSBankAccount> {
    constructor() {
        super("viam.app.v1.PaymentMethodUSBankAccount", [
            { no: 1, name: "bank_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_four_digits_account_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "routing_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "account_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "verification_info", kind: "message", T: () => VerificationInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.PaymentMethodUSBankAccount
 */
export const PaymentMethodUSBankAccount = new PaymentMethodUSBankAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentMonthUsageRequest$Type extends MessageType<GetCurrentMonthUsageRequest> {
    constructor() {
        super("viam.app.v1.GetCurrentMonthUsageRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetCurrentMonthUsageRequest
 */
export const GetCurrentMonthUsageRequest = new GetCurrentMonthUsageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageCost$Type extends MessageType<UsageCost> {
    constructor() {
        super("viam.app.v1.UsageCost", [
            { no: 1, name: "resource_type", kind: "enum", T: () => ["viam.app.v1.UsageCostType", UsageCostType, "USAGE_COST_TYPE_"] },
            { no: 2, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UsageCost
 */
export const UsageCost = new UsageCost$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceUsageCostsBySource$Type extends MessageType<ResourceUsageCostsBySource> {
    constructor() {
        super("viam.app.v1.ResourceUsageCostsBySource", [
            { no: 1, name: "source_type", kind: "enum", T: () => ["viam.app.v1.SourceType", SourceType, "SOURCE_TYPE_"] },
            { no: 2, name: "resource_usage_costs", kind: "message", T: () => ResourceUsageCosts },
            { no: 3, name: "tier_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ResourceUsageCostsBySource
 */
export const ResourceUsageCostsBySource = new ResourceUsageCostsBySource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceUsageCosts$Type extends MessageType<ResourceUsageCosts> {
    constructor() {
        super("viam.app.v1.ResourceUsageCosts", [
            { no: 1, name: "usage_costs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsageCost },
            { no: 2, name: "discount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "total_with_discount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "total_without_discount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ResourceUsageCosts
 */
export const ResourceUsageCosts = new ResourceUsageCosts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentMonthUsageResponse$Type extends MessageType<GetCurrentMonthUsageResponse> {
    constructor() {
        super("viam.app.v1.GetCurrentMonthUsageResponse", [
            { no: 1, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 14, name: "resource_usage_costs_by_source", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceUsageCostsBySource },
            { no: 15, name: "subtotal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "cloud_storage_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "data_upload_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "data_egres_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "remote_control_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "standard_compute_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "discount_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "total_usage_with_discount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "total_usage_without_discount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "per_machine_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "binary_data_cloud_storage_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "other_cloud_storage_usage_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetCurrentMonthUsageResponse
 */
export const GetCurrentMonthUsageResponse = new GetCurrentMonthUsageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgBillingInformationRequest$Type extends MessageType<GetOrgBillingInformationRequest> {
    constructor() {
        super("viam.app.v1.GetOrgBillingInformationRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrgBillingInformationRequest
 */
export const GetOrgBillingInformationRequest = new GetOrgBillingInformationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgBillingInformationResponse$Type extends MessageType<GetOrgBillingInformationResponse> {
    constructor() {
        super("viam.app.v1.GetOrgBillingInformationResponse", [
            { no: 1, name: "type", kind: "enum", T: () => ["viam.app.v1.PaymentMethodType", PaymentMethodType, "PAYMENT_METHOD_TYPE_"] },
            { no: 2, name: "billing_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "method", kind: "message", T: () => PaymentMethodCard },
            { no: 4, name: "billing_tier", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "method_us_bank_account", kind: "message", T: () => PaymentMethodUSBankAccount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrgBillingInformationResponse
 */
export const GetOrgBillingInformationResponse = new GetOrgBillingInformationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicesSummaryRequest$Type extends MessageType<GetInvoicesSummaryRequest> {
    constructor() {
        super("viam.app.v1.GetInvoicesSummaryRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetInvoicesSummaryRequest
 */
export const GetInvoicesSummaryRequest = new GetInvoicesSummaryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicesSummaryResponse$Type extends MessageType<GetInvoicesSummaryResponse> {
    constructor() {
        super("viam.app.v1.GetInvoicesSummaryResponse", [
            { no: 1, name: "outstanding_balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "invoices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoiceSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetInvoicesSummaryResponse
 */
export const GetInvoicesSummaryResponse = new GetInvoicesSummaryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicePdfRequest$Type extends MessageType<GetInvoicePdfRequest> {
    constructor() {
        super("viam.app.v1.GetInvoicePdfRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetInvoicePdfRequest
 */
export const GetInvoicePdfRequest = new GetInvoicePdfRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicePdfResponse$Type extends MessageType<GetInvoicePdfResponse> {
    constructor() {
        super("viam.app.v1.GetInvoicePdfResponse", [
            { no: 1, name: "chunk", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetInvoicePdfResponse
 */
export const GetInvoicePdfResponse = new GetInvoicePdfResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendPaymentRequiredEmailRequest$Type extends MessageType<SendPaymentRequiredEmailRequest> {
    constructor() {
        super("viam.app.v1.SendPaymentRequiredEmailRequest", [
            { no: 1, name: "customer_org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "billing_owner_org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SendPaymentRequiredEmailRequest
 */
export const SendPaymentRequiredEmailRequest = new SendPaymentRequiredEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendPaymentRequiredEmailResponse$Type extends MessageType<SendPaymentRequiredEmailResponse> {
    constructor() {
        super("viam.app.v1.SendPaymentRequiredEmailResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SendPaymentRequiredEmailResponse
 */
export const SendPaymentRequiredEmailResponse = new SendPaymentRequiredEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAvailableBillingTiersRequest$Type extends MessageType<GetAvailableBillingTiersRequest> {
    constructor() {
        super("viam.app.v1.GetAvailableBillingTiersRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetAvailableBillingTiersRequest
 */
export const GetAvailableBillingTiersRequest = new GetAvailableBillingTiersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAvailableBillingTiersResponse$Type extends MessageType<GetAvailableBillingTiersResponse> {
    constructor() {
        super("viam.app.v1.GetAvailableBillingTiersResponse", [
            { no: 1, name: "tiers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetAvailableBillingTiersResponse
 */
export const GetAvailableBillingTiersResponse = new GetAvailableBillingTiersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationBillingTierRequest$Type extends MessageType<UpdateOrganizationBillingTierRequest> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationBillingTierRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "billing_tier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationBillingTierRequest
 */
export const UpdateOrganizationBillingTierRequest = new UpdateOrganizationBillingTierRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationBillingTierResponse$Type extends MessageType<UpdateOrganizationBillingTierResponse> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationBillingTierResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationBillingTierResponse
 */
export const UpdateOrganizationBillingTierResponse = new UpdateOrganizationBillingTierResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationBillingOrganizationRequest$Type extends MessageType<GetLocationBillingOrganizationRequest> {
    constructor() {
        super("viam.app.v1.GetLocationBillingOrganizationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetLocationBillingOrganizationRequest
 */
export const GetLocationBillingOrganizationRequest = new GetLocationBillingOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationBillingOrganizationResponse$Type extends MessageType<GetLocationBillingOrganizationResponse> {
    constructor() {
        super("viam.app.v1.GetLocationBillingOrganizationResponse", [
            { no: 1, name: "billing_organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetLocationBillingOrganizationResponse
 */
export const GetLocationBillingOrganizationResponse = new GetLocationBillingOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationBillingOrganizationRequest$Type extends MessageType<UpdateLocationBillingOrganizationRequest> {
    constructor() {
        super("viam.app.v1.UpdateLocationBillingOrganizationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "billing_organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateLocationBillingOrganizationRequest
 */
export const UpdateLocationBillingOrganizationRequest = new UpdateLocationBillingOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationBillingOrganizationResponse$Type extends MessageType<UpdateLocationBillingOrganizationResponse> {
    constructor() {
        super("viam.app.v1.UpdateLocationBillingOrganizationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateLocationBillingOrganizationResponse
 */
export const UpdateLocationBillingOrganizationResponse = new UpdateLocationBillingOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChargeOrganizationRequest$Type extends MessageType<ChargeOrganizationRequest> {
    constructor() {
        super("viam.app.v1.ChargeOrganizationRequest", [
            { no: 1, name: "org_id_to_charge", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "subtotal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "tax", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "org_id_for_branding", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "disable_confirmation_email", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ChargeOrganizationRequest
 */
export const ChargeOrganizationRequest = new ChargeOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChargeOrganizationResponse$Type extends MessageType<ChargeOrganizationResponse> {
    constructor() {
        super("viam.app.v1.ChargeOrganizationResponse", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ChargeOrganizationResponse
 */
export const ChargeOrganizationResponse = new ChargeOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateInvoiceAndChargeImmediatelyRequest$Type extends MessageType<CreateInvoiceAndChargeImmediatelyRequest> {
    constructor() {
        super("viam.app.v1.CreateInvoiceAndChargeImmediatelyRequest", [
            { no: 1, name: "org_id_to_charge", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "org_id_for_branding", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "disable_email", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateInvoiceAndChargeImmediatelyRequest
 */
export const CreateInvoiceAndChargeImmediatelyRequest = new CreateInvoiceAndChargeImmediatelyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateInvoiceAndChargeImmediatelyResponse$Type extends MessageType<CreateInvoiceAndChargeImmediatelyResponse> {
    constructor() {
        super("viam.app.v1.CreateInvoiceAndChargeImmediatelyResponse", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateInvoiceAndChargeImmediatelyResponse
 */
export const CreateInvoiceAndChargeImmediatelyResponse = new CreateInvoiceAndChargeImmediatelyResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.v1.BillingService
 */
export const BillingService = new ServiceType("viam.app.v1.BillingService", [
    { name: "GetCurrentMonthUsage", options: {}, I: GetCurrentMonthUsageRequest, O: GetCurrentMonthUsageResponse },
    { name: "GetOrgBillingInformation", options: {}, I: GetOrgBillingInformationRequest, O: GetOrgBillingInformationResponse },
    { name: "GetInvoicesSummary", options: {}, I: GetInvoicesSummaryRequest, O: GetInvoicesSummaryResponse },
    { name: "GetInvoicePdf", serverStreaming: true, options: {}, I: GetInvoicePdfRequest, O: GetInvoicePdfResponse },
    { name: "SendPaymentRequiredEmail", options: {}, I: SendPaymentRequiredEmailRequest, O: SendPaymentRequiredEmailResponse },
    { name: "GetAvailableBillingTiers", options: {}, I: GetAvailableBillingTiersRequest, O: GetAvailableBillingTiersResponse },
    { name: "UpdateOrganizationBillingTier", options: {}, I: UpdateOrganizationBillingTierRequest, O: UpdateOrganizationBillingTierResponse },
    { name: "GetLocationBillingOrganization", options: {}, I: GetLocationBillingOrganizationRequest, O: GetLocationBillingOrganizationResponse },
    { name: "UpdateLocationBillingOrganization", options: {}, I: UpdateLocationBillingOrganizationRequest, O: UpdateLocationBillingOrganizationResponse },
    { name: "ChargeOrganization", options: {}, I: ChargeOrganizationRequest, O: ChargeOrganizationResponse },
    { name: "CreateInvoiceAndChargeImmediately", options: {}, I: CreateInvoiceAndChargeImmediatelyRequest, O: CreateInvoiceAndChargeImmediatelyResponse }
]);
